import { useLingui } from "@lingui/react/macro";
import { multipleLabel, type BatchScale } from "@/lib/recipes/staged-method";

/** "Full batch · 32", "Half batch", "5× batch · 160": the batch a card's quantities are for. */
export function useBatchLabel(scale: BatchScale, yieldCount: string | null): string {
  const { t } = useLingui();
  const multiple = multipleLabel(scale);
  if (scale === 1) return yieldCount ? t`Full batch · ${yieldCount}` : t`Full batch`;
  if (scale === 0.5) return yieldCount ? t`Half batch · ${yieldCount}` : t`Half batch`;
  return yieldCount ? t`${multiple} batch · ${yieldCount}` : t`${multiple} batch`;
}
